// UserTable.js
import React, { useState } from "react";
import { FaEye, FaComments, FaCheck } from "react-icons/fa"; // Import eye, chat, and check icons
import UserDetailModal from "./UserDetailModal"; // Import the modal

const formatFlowType = (flowType) => {
  return (flowType || "chat_escalation")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const UserTable = ({ users, onUserSelect, onResolve }) => {
  const [selectedUser, setSelectedUser] = useState(null); // State to manage the selected user
  const [resolvingIds, setResolvingIds] = useState(new Set());

  const handleOpenModal = (user) => {
    setSelectedUser(user);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
  };

  const handleResolveClick = async (user) => {
    if (!onResolve || resolvingIds.has(user.escalation_request_id)) return;

    setResolvingIds((prevIds) => new Set(prevIds).add(user.escalation_request_id));
    try {
      await onResolve(user);
    } finally {
      setResolvingIds((prevIds) => {
        const nextIds = new Set(prevIds);
        nextIds.delete(user.escalation_request_id);
        return nextIds;
      });
    }
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full border border-gray-200 bg-white">
        <thead>
          <tr className="w-full bg-gray-100 text-sm uppercase leading-normal text-gray-600">
            <th className="py-3 px-6 text-left">Name</th>
            <th className="py-3 px-6 text-left">Email</th>
            <th className="py-3 px-6 text-left">Phone</th>
            <th className="py-3 px-6 text-left">Room No</th>
            <th className="py-3 px-6 text-left">Action</th>
          </tr>
        </thead>
        <tbody className="text-sm font-light text-gray-600">
          {users.map((user) => (
            <tr key={user.id} className="border-b border-gray-200 hover:bg-gray-100">
              <td className="py-3 px-6">{user.name}</td>
              <td className="py-3 px-6">{user.email}</td>
              <td className="py-3 px-6">{user.phone}</td>
              <td className="py-3 px-6">{user.roomNo || "N/A"}</td>
              <td className="flex justify-center space-x-3 py-3 px-6">
                {user.flowType === "chat_escalation" && !user.isResolved && (
                  <div className="relative">
                    <button
                      onClick={() => onUserSelect(user)}
                      className="flex items-center justify-center text-gray-600 hover:text-gray-900"
                    >
                      <FaComments className="h-5 w-5" />
                    </button>
                    {!user.is_read && (
                      <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-blue-500"></span>
                    )}
                  </div>
                )}
                <button
                  onClick={() => handleOpenModal(user)}
                  className="text-gray-600 hover:text-gray-900"
                >
                  <FaEye />
                </button>
                {!user.isResolved && onResolve && (
                  <button
                    onClick={() => handleResolveClick(user)}
                    className="text-green-600 transition-colors hover:text-green-900 disabled:cursor-not-allowed disabled:opacity-50"
                    disabled={resolvingIds.has(user.escalation_request_id)}
                    title="Resolve this request"
                    aria-label={`Resolve request for ${user.name}`}
                  >
                    <FaCheck />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Render the modal */}
      {selectedUser && <UserDetailModal user={selectedUser} onClose={handleCloseModal} />}
    </div>
  );
};

export default UserTable;
